import { QueryOptions, useQuery } from "react-query";
import { useFetchContext } from "../common/FetchContext";
import { urls } from "../common/urls";

export const useReportSequenceDefinitionDetails = (id: string) => {
  const { authAxios } = useFetchContext();

  const getReportSequenceDefinitionDetails = async (): Promise<any> => {
    const { data } = await authAxios.get(
      urls.testSequenceDefinitions.mockTraveler(id)
    );
    return data;
  };

  return useQuery<any, any>(
    ["ReportSequenceDefinitionDetails", id],
    getReportSequenceDefinitionDetails,
    {
      enabled: id !== undefined && id !== null && id !== "",
    }
  );
};

export const useReportSequenceDefinition = (id: string) => {
  const { authAxios } = useFetchContext();

  const getReportSequenceDefinition = async (): Promise<any> => {
    const { data } = await authAxios.get(
      `reportsequencedefinition/${id}/rsd_full_view/`
    );

    return data;
    // if(data.length!=0){
    //   return data;
    // }else{
    //   return {}
    // }
    // return data
    
  };

  return useQuery<any, any>(
    ["ReportSequenceDefinition", id],
    getReportSequenceDefinition,
    { enabled: id !== undefined && id !== null && id !== "" }
  );
};

export const useReportSequenceDefinitions = (
  options: QueryOptions<any, any> = {}
) => {
  const { authAxios } = useFetchContext();

  const getReportSequenceDefinitions = async (): Promise<any> => {
    const { data } = await authAxios.get("reportsequencedefinition?limit=-1");

    return data.results;
  };

  return useQuery<any, any>(
    ["report_sequence_definitions"],
    getReportSequenceDefinitions,
    options
  );
};

export const useReportSequenceDefinitionsAvailable = (
  options: QueryOptions<any, any> = {}
) => {
  const { authAxios } = useFetchContext();

  const getReportSequenceDefinitions = async (): Promise<any> => {
    const { data } = await authAxios.get("reportsequencedefinition/?disposition=16&limit=-1");

    return data.results;
  };

  return useQuery<any, any>(
    ["report_sequence_definitions"],
    getReportSequenceDefinitions,
    options
  );
};
